import axios from '@/axios.js'
import Vue from 'vue'
export default {
  fetchCourseReport ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/reports/allCourses')
        .then((response) => {
          commit('SET_COURSE_REPORT', response.data.data.list)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
  fetchLessonReport ({ commit }) {
    return new Promise((resolve, reject) => {
      axios
        .get('/reports/lessonWiseData')
        .then((response) => {
          commit('SET_LESSON_REPORT', response.data.data.list)
          resolve(response)
        })
        .catch((error) => {
          reject(error)
        })
    })
  },
}
